import { Component, inject } from '@angular/core';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  FormArray,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { ClientService } from 'src/app/shared/service/disbursment/client.service';
import { DisbursmentService } from 'src/app/shared/service/disbursment/disbursment.service';
import { PortAgentFormService } from 'src/app/shared/service/disbursment/port-agent-form.service';
import { PortService } from 'src/app/shared/service/disbursment/port.service';
import { MaCargo } from '../dis-repository/pages/create-cargo/cargo.model';
import { MaVessel } from '../dis-repository/pages/create-client/vessel.model';
import { MaPortAgent } from '../dis-repository/pages/create-port-agent/port-agent.model';
import { ConfirmationDialogComponent } from '../dis-repository/pages/create-port-tariff/confirmation-dialog.component';
import { MaCountry } from '../dis-repository/pages/create-port-tariff/country.model';
import { MaPort } from '../dis-repository/pages/create-port-tariff/port.model';
import { MaPurpose } from '../dis-repository/pages/create-purpose/purpose.model';
import {
  AddedFields,
  getMainServiceSerialNumber,
  restrictDecimal,
  getOptionValuefortheFields,
  displayFn,
  removeAddedFieldsAndControls,
  getPurposeName,
  filterServicesOnPurpose,
  mergeResponseVesselIntoList,
  getCompanyIdByName,
  formatToLocalISOString,
  getAdditionalPropertiesObjectFromForm,
  replaceMovementPart,
  getCurrencyFromCountry,
  addAdditionalFieldsToFieldsArray,
  clearVesselDetails,
} from '../pda/pda.model';
import {
  PA_Rules,
  fdaFields,
  Field,
  Rules,
} from '../pda/port-agent-form.model';
import { FdaDisbursementList } from '../disbursment/disbursment.component.model';
import { ToastrService } from 'ngx-toastr';
import { FdaService } from 'src/app/shared/service/disbursment/fda.component.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-fda',
  templateUrl: './fda.component.html',
  styleUrls: ['./fda.component.scss'],
})
export class FdaComponent {
  private loader = inject(DisbursmentService);
  isLoading$ = this.loader.loading$;
  fdaCreateForm!: FormGroup;
  countryList: MaCountry[] = [];
  portList: MaPort[] = [];
  vesselList: MaVessel[] = [];
  purposeList: MaPurpose[] = [];
  portAgentList: MaPortAgent[] = [];
  cargoList: MaCargo[] = [];
  clientList: MaPortAgent[] = [];
  currencyList: string[] = [];
  serviceList: PA_Rules = new PA_Rules();
  columnsToDisplayWithExpand = ['sno', 'service', 'formula', 'value'];
  disableTableInputFields: boolean = false;
  merakiGrandTotal = 0;

  fields = fdaFields
    .map((field: any) => {
      if (field.name === 'Vessel') {
        return { ...field, value: 'vessel_id' };
      }

      // Make FromCurrency readonly on edit
      if (field.name === 'FromCurrency') {
        return { ...field, pdareadOnly: true };
      }

      return field;
    })
    .filter((field) => field.createPdaForm === true);

  addedFields: AddedFields[] = [];
  companyList: { company_id: number; company_name: string }[] = [];
  filteredOptions: { [key: string]: any[] } = {};
  disbursementIdList: FdaDisbursementList[] = [];
  disbursementId: any[] = [];
  allDataLoaded = false;
  searchTerm: string = '';
  datasource: any = [];
  disbursementCtrl = new FormControl('');
  filteredDisbursementId: string[] = [];
  errMsg: string = '';
  disbursementSeq: number[] = [];
  submitButtonForAPI: boolean = false;
  selectedDisbursementSeq: number = 0;
  displayedColumns: string[] = ['Sl.No', 'service', 'formula', 'value'];
  disableSubmitButton: boolean = false;
  previousFormData: any = {};
  portServiceList: PA_Rules = new PA_Rules();
  previousPurposeId: number = 0;
  isServiceCalculated: boolean = false;
  tariffRules: PA_Rules = new PA_Rules();
  port_tariff_rule_calculate: PA_Rules = new PA_Rules();

  constructor(
    private fb: FormBuilder,
    private portService: PortService,
    private clientService: ClientService,
    private snackBar: ToastrService,
    private portAgentFormService: PortAgentFormService,
    private router: Router,
    private route: ActivatedRoute,
    private fdaService: FdaService,
    private dialog: MatDialog,
         private requestFormService: RequestFormService,
  ) {
    this.buildPortAgentForm();
  }

  get serviceListFormArray(): FormArray {
    return this.fdaCreateForm.get('serviceList') as FormArray;
  }

  buildPortAgentForm() {
    this.fdaCreateForm = this.fb.group({
      fdaFromPDA: [false],
      disbursementId: [{ value: '', disabled: true }, Validators.required],
      disbursementSeq: [{ value: '', disabled: true }, Validators.required],
      country_id: [null, Validators.required],
      client_id: [null, Validators.required],
      portagent_id: [null, Validators.required],
      cargo_id: [null, Validators.required],
      port_id: [null, Validators.required],
      imo_number: [null, [Validators.required, Validators.maxLength(7)]],
      vessel_id: [null, Validators.required],
      vessel: [null, Validators.required],
      nrt: [null, Validators.required],
      grt: [null, Validators.required],
      rgrt: [null],
      loa: [null, Validators.required],
      beam: [null, Validators.required],
      depth: [null, Validators.required],
      type: [''],
      dwt: [null, Validators.required],
      purpose_id: [null, Validators.required],
      eta: [null, [Validators.required]],
      etd: [null, [Validators.required]],
      vessel_stay: [null, Validators.required],
      fda_roe: [null, Validators.required],
      voyage: [null, Validators.required],
      fda_currency_from: [null, Validators.required],
      fda_currency_to: [null, Validators.required],
      invoice_ref_no: [null, Validators.required],
    });
  }
  getMainServiceIndex = getMainServiceSerialNumber;
  restrictDecimal = restrictDecimal;
  getOptionValue = getOptionValuefortheFields;
  displayFn = displayFn;

  ngOnInit(): void {
this.route.queryParams.subscribe(params => {
    const disbursementId = params['disbursement_id'];
    const pic = params['pic'];

    console.log(disbursementId, pic);

    this.getDisbursmentDataFromDb(disbursementId);
  });
    this.initForm();
    this.getAllMasterData();
    this.disbursementAutocomplete();
  }

  disbursementAutocomplete() {
    this.filteredDisbursementId = [...this.disbursementId];
    this.fdaCreateForm
      .get('disbursementId')
      ?.valueChanges.subscribe((value) => {
        this.filteredDisbursementId = this.filterDisbursement(value || '');
      });
  }

  onDisbursementSelected(selectedValue: string) {
    removeAddedFieldsAndControls(
      this.fdaCreateForm,
      this.addedFields,
      this.fields,
    );
    const disbursementId = selectedValue.split(' - ')[0];
    const selected = this.disbursementIdList.find(
      (d) => d.disbursement_id === disbursementId,
    );
    if (selected) {
      this.selectedDisbursementSeq = selected.disbursement_seq;
      this.fdaCreateForm.patchValue({
        disbursementSeq: this.selectedDisbursementSeq,
      });
      this.loader.show();
      this.fdaService
        .getDisbursementDetails(this.selectedDisbursementSeq)
        .subscribe({
          next: async (response: any) => {
            this.tariffRules = response.port_tariff_rule;
            await this.updateFieldData(response);
            this.getAdditionalFieldData(response);
            const countryId = response?.portagent_pda_data?.country?.country_id;
            if (countryId) {
              await this.portByCountry('Country', countryId, response);
            }
            this.merakiGrandTotal =
              response?.portagent_pda_data?.services?.grand_total;
            const purpose = getPurposeName(
              this.purposeList,
              response?.portagent_pda_data?.purpose?.purpose_id,
            );
            this.portServiceList = response?.portagent_pda_data?.services;
            this.serviceList.items = filterServicesOnPurpose(
              purpose,
              this.portServiceList.items,
            );
            this.fdaCreateForm.addControl(
              'serviceList',
              this.fb.array([] as FormGroup[]),
            );
            this.snackBar.success('The data has been initiated from PDA');
            await this.vesselListByClientId(
              response?.portagent_pda_data?.client?.client_id,
              {
                vessel_id: response?.portagent_pda_data?.vessel?.vsl_id,
                vessel_name: response?.portagent_pda_data?.vessel?.name,
                imo_number: response?.portagent_pda_data?.vessel?.imo_number,
                grt: response?.portagent_pda_data?.vessel?.grt,
                rgrt: response?.portagent_pda_data?.vessel?.rgrt,
                nrt: response?.portagent_pda_data?.vessel?.nrt,
                loa: response?.portagent_pda_data?.vessel?.loa,
                beam: response?.portagent_pda_data?.vessel?.beam,
                depth: response?.portagent_pda_data?.vessel?.depth,
                dwt: response?.portagent_pda_data?.vessel?.dwt,
                type: response?.portagent_pda_data?.vessel?.type,
              },
            );
            this.populateServicesFromList();
            this.disableFields();
            this.loader.hide();
          },
          error: (err: any) => {
            this.loader.hide();
            this.errMsg =
              err?.error?.error ||
              'Something went wrong please try again later.';
            this.snackBar.error(this.errMsg);
          },
        });
    }
  }

  disableFields() {
    const controlsToDisable = [
      'portagent_id',
      'client_id',
      'port_id',
      'country_id',
      'vessel_id',
      'imo_number',
      'purpose_id',
    ];
    controlsToDisable.forEach((controlName) => {
      const ctrl = this.fdaCreateForm.get(controlName);
      const disbursementId = this.fdaCreateForm.get('disbursementId')?.value;
      const currentValue = ctrl?.value;
      if (ctrl && disbursementId) {
        ctrl.disable({ emitEvent: false });
        ctrl.setValue(currentValue, { emitEvent: false });
      } else {
        ctrl?.enable({ emitEvent: false });
        ctrl?.setValue(currentValue, { emitEvent: false });
      }
    });
  }

  getAdditionalFieldData(response: any) {
    const additionalProperties =
      response?.pda_vessel_details?.additional_property || [];
    this.addedFields = additionalProperties.map((item: any) => ({
      fieldName: item?.field_name,
      controlName: item?.field_name,
      is_mandatory: item?.is_mandatory,
    }));

    // Add missing fields to the fields array for rendering
    additionalProperties.forEach((item: any) => {
      const fieldName = item?.field_name?.trim();
      if (!fieldName) return;
      const existsInFields = this.fields.some(
        (f: any) => f.value?.trim() === fieldName,
      );
      if (!existsInFields) {
        this.fields.push({
          name: fieldName,
          label: fieldName,
          value: fieldName,
          type: 'input',
        });
      }
    });

    this.addedFields?.forEach((field: any) => {
      const matchingProp = additionalProperties?.find((prop: any) => {
        return prop?.field_name === field.fieldName;
      });
      const isMandatory = field.is_mandatory === 'Y';
      const value = matchingProp?.value ?? null;
      if (!this.fdaCreateForm.contains(field.controlName)) {
        this.fdaCreateForm.addControl(
          field.controlName,
          this.fb.control(value, isMandatory ? Validators.required : []),
        );
      } else {
        this.fdaCreateForm.get(field.controlName)?.patchValue(value);
      }
    });
  }

  updateFieldData(response: any): Promise<void> {
    return new Promise((resolve) => {
      this.fdaCreateForm.patchValue({
        country_id: response?.portagent_pda_data?.country?.country_id,
        client_id: response?.portagent_pda_data?.client?.client_id,
        portagent_id: response?.portagent_id,
        cargo_id: response?.portagent_pda_data?.cargo?.cargo_id,
        port_id: response?.portagent_pda_data?.port?.port_id,
        imo_number: response?.portagent_pda_data?.vessel?.imo_number,
        vessel_id: response?.portagent_pda_data?.vessel?.vsl_id,
        vessel: response?.portagent_pda_data?.vessel?.name,
        nrt: response?.portagent_pda_data?.vessel?.nrt,
        grt: response?.portagent_pda_data?.vessel?.grt,
        rgrt: response?.portagent_pda_data?.vessel?.rgrt,
        loa: response?.portagent_pda_data?.vessel?.loa,
        beam: response?.portagent_pda_data?.vessel?.beam,
        depth: response?.portagent_pda_data?.vessel?.depth,
        type: response?.portagent_pda_data?.vessel?.type,
        dwt: response?.portagent_pda_data?.vessel?.dwt,
        purpose_id: response?.portagent_pda_data?.purpose?.purpose_id,
        eta: response?.portagent_pda_data?.eta,
        etd: response?.portagent_pda_data?.etd,
        vessel_stay: response?.portagent_pda_data?.vessel_stay || '0D 0h',
        fda_roe: response?.pda_roe,
        voyage: response?.portagent_pda_data?.voyage,
        fda_currency_from: response?.pda_currency_from,
        fda_currency_to: response?.pda_currency_to,
        invoice_ref_no: response?.invoice_ref_no || null,
      });
      resolve();
    });
  }

  portByCountry(fieldName: string, value: any, response: any): Promise<any> {
    return new Promise((resolve, reject) => {
      if (fieldName === 'Country') {
        this.loader.show();
        this.portService.getPortsByCountryId(value).subscribe({
          next: (ports) => {
            this.portList = ports;
            this.fields.map((field) => {
              if (field.name === 'Port') {
                field.options = this.portList.map((port: any) => ({
                  port_id: port.port_id,
                  name: port.name,
                }));

                this.filteredOptions[field.value] = field.options;

                // Re-set the control's value to itself to force displayWith to resolve the label
                const currentPortValue = this.fdaCreateForm.get(
                  field.value,
                )?.value;
                if (
                  currentPortValue !== null &&
                  currentPortValue !== undefined
                ) {
                  this.fdaCreateForm
                    .get(field.value)
                    ?.setValue(currentPortValue, { emitEvent: false });
                }
              }
            });

            const port_id = this.fdaCreateForm.get('port_id')?.value;
            this.addAdditionalFieldsToFieldsArray(port_id);
            this.loader.hide();
            resolve(ports); // ✅ Resolve when done
          },
          error: (error: any) => {
            this.portList = [];
            this.loader.hide();
            this.errMsg =
              error?.error?.error ||
              'Something went wrong please try again later.';
            this.snackBar.error(this.errMsg);

            reject(error); //  Reject on error
          },
        });
      } else {
        resolve(null); //  In case fieldName isn’t "Country"
      }
    });
  }

  vesselListByClientId(clientId: number, vesselDetails?: any) {
    return new Promise((resolve, reject) => {
      this.loader.show();
      const vslpayload = {
        company_id: clientId,
        fields: ['assigned_unassigned'],
      };
      this.clientService.VslListFromDb(vslpayload).subscribe({
        next: (response: any) => {
          this.vesselList = mergeResponseVesselIntoList(
            response.assigned_vessels || [],
            vesselDetails || this.getCurrentVesselDetails(),
          );
          this.fields.map((field) => {
            if (field.name === 'Vessel') {
              field.options = this.vesselList.map((vessel: any) => ({
                vessel_id: vessel.vessel_id,
                name: vessel.name,
              }));
              this.filteredOptions[field.value] = field.options;
              // ensure the vessel control shows the display label if value already patched
              const currentVessel = this.fdaCreateForm.get(field.value)?.value;
              if (currentVessel !== null && currentVessel !== undefined) {
                this.fdaCreateForm
                  .get(field.value)
                  ?.setValue(currentVessel, { emitEvent: false });
              }
            }
          });
          this.loader.hide();
          resolve(response);
        },
        error: (error: any) => {
          this.vesselList = [];
          this.errMsg = error?.error?.error || 'Failed to fetch vessel details';
          this.snackBar.error(this.errMsg);
          this.loader.hide();
          reject(error);
        },
      });
    });
  }

  private getCurrentVesselDetails(): any {
    const vesselId = this.fdaCreateForm.get('vessel_id')?.value;
    if (!vesselId) {
      return null;
    }

    return {
      vessel_id: vesselId,
      vessel_name: this.fdaCreateForm.get('vessel')?.value,
      imo_number: this.fdaCreateForm.get('imo_number')?.value,
      grt: this.fdaCreateForm.get('grt')?.value,
      rgrt: this.fdaCreateForm.get('rgrt')?.value,
      nrt: this.fdaCreateForm.get('nrt')?.value,
      loa: this.fdaCreateForm.get('loa')?.value,
      beam: this.fdaCreateForm.get('beam')?.value,
      depth: this.fdaCreateForm.get('depth')?.value,
      dwt: this.fdaCreateForm.get('dwt')?.value,
      type: this.fdaCreateForm.get('type')?.value,
    };
  }

  addAdditionalFieldsToFieldsArray(
    port_id: number,
  ): { fieldName: string; controlName: string }[] {
    const selectedPort = this.portList.find((port) => port.port_id === port_id);
    if (selectedPort) {
      const addVslFields: Field[] = selectedPort.vessel_fields
        .filter((vf) => !!vf.field_name)
        .map((vf) => {
          const controlName = vf.field_name!;
          return {
            name: vf.field_name as string,
            value: controlName,
            type: vf.data_type === 'date' ? 'date' : 'input',
            data_type: vf.data_type ?? '',
            options: [],
          };
        });
      addVslFields.forEach((field) => {
        const alreadyExists = this.fields.some((f) => f.value === field.value);
        if (!alreadyExists) {
          this.fields.push(field);
          this.fdaCreateForm.addControl(
            field.value,
            this.fb.control(null, Validators.required),
          );
        }
      });
    }
    return this.addedFields;
  }

  convertMinutesToDaysHoursShort(minutes: number): string {
    if (!minutes || isNaN(minutes) || minutes <= 0) {
      return '0D 0h';
    }
    const days = Math.floor(minutes / 1440);
    const hours = Math.floor((minutes % 1440) / 60);
    return `${days}D ${hours}h`;
  }

  private filterDisbursement(value: string | null): string[] {
    if (!value) {
      return this.disbursementId;
    }
    const filterValue = value?.toLowerCase();
    return this.disbursementId.filter((dis) =>
      dis.toLowerCase().includes(filterValue),
    );
  }

  setupAutocomplete(): void {
    this.fields.forEach((field) => {
      if (field.type === 'select') {
        this.filteredOptions[field.value] = field.options || [];
        this.fdaCreateForm.get(field.value)?.valueChanges.subscribe((value) => {
          this.filteredOptions[field.value] = this.autoCompleteFilter(
            field,
            value,
          );
        });
      }
    });
  }

  private autoCompleteFilter(field: any, value: string): any[] {
    const filterValue = (value || '').toString().toLowerCase();
    return (field.options || []).filter((opt: any) => {
      const label =
        field.name === 'Cargo'
          ? opt?.type
          : field.name === 'ToCurrency' || field.name === 'FromCurrency'
            ? opt
            : opt?.name;

      return label?.toLowerCase().includes(filterValue);
    });
  }

  getFilteredOptions(field: any): any[] {
    return this.filteredOptions[field.value] || [];
  }

  getAllMasterData(): void {
    this.swapFields();
    this.loader.show();
    const params = {
      fields: ['all'],
    };
    this.portAgentFormService.getMasterData(params).subscribe({
      next: (response: any) => {
        this.countryList = response.country;
        this.purposeList = response.purpose;
        this.portAgentList = response.port_agent;
        this.clientList = response.client;
        this.cargoList = response.cargo;
        this.vesselList = response.vessel;
        this.companyList = response.companies;
        this.currencyList = response.currency;
        this.formatFieldData(this.fields);
        this.setupAutocomplete();
        this.loader.hide();
      },
      error: (err: any) => {
        this.loader.hide();
      },
    });
  }

  swapFields() {
    const imoIndex = this.fields.findIndex(
      (f) => f.name?.trim() === 'IMO Number',
    );
    const vesselIndex = this.fields.findIndex(
      (f) => f.name?.trim() === 'Vessel',
    );

    if (imoIndex !== -1 && vesselIndex !== -1) {
      const temp = this.fields[imoIndex];
      this.fields[imoIndex] = this.fields[vesselIndex];
      this.fields[vesselIndex] = temp;
      this.fields[imoIndex].type = 'select';
      this.fields[vesselIndex].type = 'input';
    }
  }

  setValidationForSubmit() {
    // Fields that should not be required
    const excludedFields = [
      'rgrt',
      'type',
      'invoice_ref_no',
      'serviceList',
      'fdaFromPDA',
    ];

    Object.keys(this.fdaCreateForm.controls).forEach((key) => {
      this.fdaCreateForm.get(key)?.clearValidators();
      this.fdaCreateForm.get(key)?.updateValueAndValidity({ emitEvent: false });
    });

    Object.keys(this.fdaCreateForm.controls).forEach((key) => {
      // Skip excluded fields
      if (excludedFields.includes(key)) {
        return;
      }

      // Check if it's an added field with is_mandatory = 'N'
      const field = this.addedFields.find((f) => f.controlName === key);
      if (field && field.is_mandatory === 'N') {
        return;
      }

      // Add required validator to all other fields
      this.fdaCreateForm.get(key)?.setValidators([Validators.required]);
      this.fdaCreateForm.get(key)?.updateValueAndValidity();
    });
  }

  onCalculate() {
    this.setValidationForSubmit();
    this.fdaCreateForm.markAllAsTouched();
    if (this.fdaCreateForm.valid) {
      // include disabled controls' values as well
      this.loader.show();
      const formData = this.fdaCreateForm.getRawValue();
      const formatedJson = this.transformJsonDataToCalculate(formData);
      this.fdaService.fdaWithoutPda(formatedJson).subscribe({
        next: (response: any) => {
          this.tariffRules = response.port_tariff_rule;
          this.merakiGrandTotal =
            response?.meraki_pda_data?.services?.grand_total;
          this.portServiceList = response?.meraki_pda_data.services;
          this.port_tariff_rule_calculate = response.port_tariff_rule;
          // Filter services based on purpose
          const purposeId = formData.purpose_id;
          const purpose = this.purposeList.find(
            (p) => p.purpose_id === purposeId,
          )?.name;
          if (purpose) {
            this.serviceList.items = filterServicesOnPurpose(
              purpose,
              this.portServiceList.items,
            );
          }

          this.fdaCreateForm.addControl(
            'serviceList',
            this.fb.array([] as FormGroup[]),
          );
          this.snackBar.success('The data has been calculated');
          this.populateServicesFromList();
          this.loader.hide();
          this.isServiceCalculated = true;
        },
        error: (error: any) => {
          this.loader.hide();
          const errMsg = error?.error?.error || 'Failed to calculate FDA data';
          this.snackBar.error(errMsg);
        },
      });
    }
  }

  private populateServicesFromList() {
    this.serviceListFormArray?.clear();
    this.datasource = [];
    this.serviceList.items.forEach((item: any) => {
      const subServiceArray = this.fb.array(
        (item.subService || []).map((sub: any) =>
          this.fb.group({
            name: [sub.name],
            purpose: [sub.purpose],
            basic_value: [sub.basic_value],
            calculated_basic_value: [sub.calculated_basic_value],
            movement: [sub.movement],
            tariff_percent: [sub.tariff_percent],
            formula_result: [sub.formula_result],
            optional: [sub.optional === 'Y' || sub.optional === true],
            hide: [sub.hide],
            operational_flag: [sub.operational_flag],
            sub_total: [
              { value: sub.sub_total, disabled: this.disableTableInputFields },
            ],
            formula_inputs: [sub.formula_inputs],
            reference: [sub.reference],
            isSubService: [true],
            systemSubTotal: [
              {
                value: sub.systemSubTotal,
                disabled: this.disableTableInputFields,
              },
            ],
            formattedSystemMovement: [sub.movement?.split(':')[1] || 1],
          }),
        ),
      );

      const mainServiceGroup = this.fb.group({
        SNO: [item.SNO],
        code: [item.code],
        service: [item.service || ''],
        /* ** Needs to be reviewed with Team - PDA comments to be displayed in FDA -- Surjit
         * feedback: [item.feedback || this.getPdaFeedback(item.service) || ''],
         * pa_remark: [{ value: item.pa_remark || this.getPdaRemark(item.service) || '', disabled: this.disableTableInputFields }],
         */
        feedback: [item.feedback || ''],
        pa_remark: [
          {
            value: item.pa_remark || '',
            disabled: this.disableTableInputFields,
          },
        ],
        negotiate: [item.negotiate || 'N'],
        agreed: [item.agreed || 'N'],
        total: [
          { value: item.total || 0, disabled: this.disableTableInputFields },
        ],
        subService: subServiceArray,
        isSubService: [false],
        systemTotal: [
          { value: item.systemTotal, disabled: this.disableTableInputFields },
        ],
      });
      this.serviceListFormArray.push(mainServiceGroup);
    });
    this.updateDatasource();
    // Update formatted movement values after populating services
    this.updateFormattedSystemMovement();
  }

  updateDatasource() {
    this.datasource = [];
    for (let service of this.serviceListFormArray.controls) {
      this.datasource.push(service);
      const subServiceFormArray = service.get('subService') as FormArray;
      subServiceFormArray.controls.forEach((subServiceCtrl) => {
        this.datasource.push(subServiceCtrl);
      });
    }
  }

  onSubmit() {
    if (!this.submitButtonForAPI) {
      this.setValidationForSubmit();
      this.fdaCreateForm.markAllAsTouched();
      if (this.fdaCreateForm.valid) {
        // include disabled controls' values when building the payload
        this.loader.show();
        const formData = this.fdaCreateForm.getRawValue();
        const formatedJson = this.transformJsonDataToSubmit(formData);
        this.disableSubmitButton = true;
        this.fdaService.fdaWithoutPda(formatedJson).subscribe({
          next: (response: any) => {
            this.snackBar.success(response.message);
            sessionStorage.setItem(
              'disbursement_seq',
              JSON.stringify(response?.disbursement_seq),
            );
            this.router.navigate(['/dis-fda-edit']);
            this.loader.hide();
          },
          error: (error: any) => {
            this.disableSubmitButton = false;
            this.loader.hide();
            const errMsg = error?.error?.error || 'Failed to submit FDA data';
            this.snackBar.error(errMsg);
          },
        });
      }
    } else if (this.submitButtonForAPI) {
      this.setValidationForSubmit();
      this.fdaCreateForm.markAllAsTouched();
      if (this.fdaCreateForm.valid) {
        // include disabled controls' values when building the payload
        this.loader.show();
        const formData = this.fdaCreateForm.getRawValue();
        const formatedJson = this.transformJsonDataForFDAWithPDA(formData);
        this.disableSubmitButton = true;
        this.fdaService.fdaWithPda(formatedJson).subscribe({
          next: (response: any) => {
            this.snackBar.success(response.message);
            sessionStorage.setItem(
              'disbursement_seq',
              JSON.stringify(response?.disbursement_seq),
            );
            this.router.navigate(['/dis-fda']);
            this.loader.hide();
          },
          error: (error: any) => {
            this.disableSubmitButton = false;
            const errMsg = error?.error?.error || 'Failed to submit FDA data';
            this.snackBar.error(errMsg);
            this.loader.hide();
          },
        });
      }
    }
  }

  calculateVesselStayInFda = (
    eta: Date | string,
    etd: Date | string,
  ): string | null => {
    if (!eta || !etd) return null;

    const etaDate = new Date(eta);
    let etdDate = new Date(etd);

    if (
      etdDate.getHours() === 0 &&
      etdDate.getMinutes() === 0 &&
      etdDate.getSeconds() === 0
    ) {
      etdDate.setHours(23, 59, 59, 999);
    }

    // Compare only date for validation
    const etaOnly = new Date(
      etaDate.getFullYear(),
      etaDate.getMonth(),
      etaDate.getDate(),
    );
    const etdOnly = new Date(
      etdDate.getFullYear(),
      etdDate.getMonth(),
      etdDate.getDate(),
    );

    if (etdOnly.getTime() < etaOnly.getTime()) {
      return 'eta greater than etd';
    }

    const diffInMs = etdOnly.getTime() - etaOnly.getTime();
    const diffDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    if (diffInMs === 0) {
      return '1D';
    }

    return `${diffDays + 1}D`;
  };

  onDateChange() {
    const eta = this.fdaCreateForm.get('eta')?.value;
    const etd = this.fdaCreateForm.get('etd')?.value;
    const stay = this.calculateVesselStayInFda(eta, etd);
    if (stay === 'eta greater than etd') {
      this.fdaCreateForm.get('vessel_stay')?.setValue(null);
      this.fdaCreateForm.get('etd')?.setValue(null);
    } else {
      this.fdaCreateForm.get('vessel_stay')?.setValue(stay);
    }
  }

  transformJsonDataToCalculate(formData: any): any {
    return {
      comp_id: getCompanyIdByName(this.companyList),
      client_id: formData.client_id,
      portagent_id: formData.portagent_id,
      country_id: formData.country_id,
      port_id: formData.port_id,
      vessel_id: formData.vessel_id,
      imo_number: formData.imo_number,
      vessel: {
        vsl_id: formData.vessel_id?.toString() || '',
        imo_number: formData.imo_number?.toString() || '',
        name: formData.vessel?.toString() || '',
        grt: formData.grt?.toString() || '',
        nrt: formData.nrt?.toString() || '',
        loa: formData.loa?.toString() || '',
        rgrt: formData.rgrt?.toString() || '',
        beam: formData.beam?.toString() || '',
        depth: formData.depth?.toString() || '',
        dwt: formData.dwt?.toString() || '',
        type: formData.type?.toString() || '',
        additional_properties: this.getAdditionalProperties(),
      },
      cargo: {
        cargo_id: formData.cargo_id,
        type:
          this.cargoList.find((cargo) => cargo.cargo_id === formData.cargo_id)
            ?.type || null,
      },
      purpose: {
        purpose_id: formData.purpose_id,
        name:
          this.purposeList.find(
            (purpose) => purpose.purpose_id === formData.purpose_id,
          )?.name || null,
      },
      eta: formData.eta ? formatToLocalISOString(formData.eta) : null,
      etd: formData.etd ? formatToLocalISOString(formData.etd) : null,
      vessel_stay: this.convertVesselStayToMinutes(formData.vessel_stay),
      roe: +formData.fda_roe || null,
      voyage: formData.voyage,
      fda_currency_to: formData.fda_currency_to,
      fda_currency_from: formData.fda_currency_from,
      fda_custom_calculation: '',
      fda_submit: 'N',
      port_tariff_rule: {
        items:
          this.port_tariff_rule_calculate.items.length > 0
            ? this.updateMovementInTariffRules(
                this.port_tariff_rule_calculate.items,
              )
            : this.updateMovementInTariffRules(
                this.serviceList.items.map((service: any) => ({
                  ...service,
                  total: 0,
                })),
              ),
      },
    };
  }

  transformJsonDataToSubmit(formData: any): any {
    return {
      comp_id: getCompanyIdByName(this.companyList),
      client_id: formData.client_id,
      portagent_id: formData.portagent_id,
      country_id: formData.country_id,
      port_id: formData.port_id,
      vessel_id: formData.vessel_id,
      imo_number: formData.imo_number,
      vessel: {
        vsl_id: formData.vessel_id?.toString() || '',
        imo_number: formData.imo_number?.toString() || '',
        name: formData.vessel?.toString() || '',
        grt: formData.grt?.toString() || '',
        nrt: formData.nrt?.toString() || '',
        loa: formData.loa?.toString() || '',
        rgrt: formData.rgrt?.toString() || '',
        beam: formData.beam?.toString() || '',
        depth: formData.depth?.toString() || '',
        dwt: formData.dwt?.toString() || '',
        type: formData.type?.toString() || '',
        additional_properties: this.getAdditionalProperties(),
        additional_properties_object: getAdditionalPropertiesObjectFromForm(
          this.addedFields,
          this.fdaCreateForm,
          this.fields,
        ),
      },
      cargo: {
        cargo_id: formData.cargo_id,
        type:
          this.cargoList.find((cargo) => cargo.cargo_id === formData.cargo_id)
            ?.type || null,
      },
      purpose: {
        purpose_id: formData.purpose_id,
        name:
          this.purposeList.find(
            (purpose) => purpose.purpose_id === formData.purpose_id,
          )?.name || null,
      },
      eta: formData.eta ? this.formatToLocalISOString(formData.eta) : null,
      etd: formData.etd ? this.formatToLocalISOString(formData.etd) : null,
      vessel_stay: this.convertVesselStayToMinutes(formData.vessel_stay),
      roe: +formData.fda_roe || null,
      voyage: formData.voyage,
      fda_currency_to: formData.fda_currency_to,
      fda_currency_from: formData.fda_currency_from,
      fda_custom_calculation: '',
      fda_submit: 'Y',
      invoice_ref_no: formData.invoice_ref_no?.trim() || null,
      port_tariff_rule: {
        items: this.updateMovementInTariffRules(this.tariffRules.items),
      },
    };
  }

  transformJsonDataForFDAWithPDA(formData: any): any {
    // Merge services from tariff rules and port agent PDA data
    const mergedItems = [...this.tariffRules.items];

    // Check if there are services in portServiceList that are not in tariffRules
    if (this.portServiceList?.items) {
      this.portServiceList.items.forEach((pdaService) => {
        const existsInTariff = mergedItems.some(
          (tariffService) => tariffService.service === pdaService.service,
        );
        if (!existsInTariff) {
          if (pdaService) {
            pdaService.total = '';
          }
          mergedItems.push(pdaService);
        }
      });
    }

    return {
      disbursement_seq: this.selectedDisbursementSeq,
      comp_id: getCompanyIdByName(this.companyList),
      client_id: formData.client_id,
      portagent_id: formData.portagent_id,
      country_id: formData.country_id,
      port_id: formData.port_id,
      vessel_id: formData.vessel_id,
      imo_number: formData.imo_number,
      vessel: {
        vsl_id: formData.vessel_id?.toString() || '',
        imo_number: formData.imo_number?.toString() || '',
        name: formData.vessel?.toString() || '',
        grt: formData.grt?.toString() || '',
        nrt: formData.nrt?.toString() || '',
        loa: formData.loa?.toString() || '',
        rgrt: formData.rgrt?.toString() || '',
        beam: formData.beam?.toString() || '',
        depth: formData.depth?.toString() || '',
        dwt: formData.dwt?.toString() || '',
        type: formData.type?.toString() || '',
        additional_properties: this.getAdditionalProperties(),
        additional_properties_object: getAdditionalPropertiesObjectFromForm(
          this.addedFields,
          this.fdaCreateForm,
          this.fields,
        ),
      },
      cargo: {
        cargo_id: formData.cargo_id,
        type:
          this.cargoList.find((cargo) => cargo.cargo_id === formData.cargo_id)
            ?.type || null,
      },
      purpose: {
        purpose_id: formData.purpose_id,
        name:
          this.purposeList.find(
            (purpose) => purpose.purpose_id === formData.purpose_id,
          )?.name || null,
      },
      eta: formData.eta ? this.formatToLocalISOString(formData.eta) : null,
      etd: formData.etd ? this.formatToLocalISOString(formData.etd) : null,
      vessel_stay: this.convertVesselStayToMinutes(formData.vessel_stay),
      roe: +formData.fda_roe || null,
      voyage: formData.voyage,
      fda_currency_to: formData.fda_currency_to,
      fda_currency_from: formData.fda_currency_from,
      fda_custom_calculation: '',
      invoice_ref_no: formData.invoice_ref_no?.trim() || null,
      port_tariff_rule: {
        items: this.updateMovementInTariffRules(mergedItems),
      },
    };
  }

  // Method to handle movement value changes
  onMovementValueChange() {
    // Update formatted movement values when movement changes
    this.updateFormattedSystemMovement();
  }

  // Method to update formattedSystemMovement from systemMovement
  private updateFormattedSystemMovement() {
    if (!this.serviceListFormArray) return;

    this.serviceListFormArray.controls.forEach((service) => {
      const subServiceArray = service.get('subService') as FormArray;
      if (subServiceArray) {
        subServiceArray.controls.forEach((subCtrl) => {
          const movement = subCtrl.get('movement')?.value;
          if (movement && typeof movement === 'string') {
            const movementParts = movement.split(':');
            if (movementParts.length > 1) {
              subCtrl
                .get('formattedSystemMovement')
                ?.setValue(movementParts[1]);
            }
          }
        });
      }
    });
  }

  // Method to update movement values in tariff rules from form data
  private updateMovementInTariffRules(tariffItems: any[]): any[] {
    if (!this.serviceListFormArray || this.serviceListFormArray.length === 0) {
      return tariffItems;
    }

    return tariffItems.map((tariffItem: any) => {
      const formService = this.serviceListFormArray.controls
        .map((c) => c.getRawValue())
        .find((s: any) => s.service === tariffItem.service);

      if (!formService) return tariffItem;

      const updatedSubServices =
        tariffItem.subService?.map((tariffSub: any) => {
          const formSub = formService.subService?.find(
            (fs: any) => fs.name === tariffSub.name,
          );
          if (!formSub) return tariffSub;

          return {
            ...tariffSub,
            optional:
              formSub.optional === true || formSub.optional === 'Y' ? 'Y' : 'N',
            movement: (() => {
              if (!tariffSub.movement) return tariffSub.movement;

              // Get the current movement value from the form control
              const currentMovement =
                formSub.formattedSystemMovement ||
                tariffSub.movement.split(':')[1];

              // Use the replaceMovementPart function for consistency
              return replaceMovementPart(
                tariffSub.movement,
                1,
                currentMovement,
              );
            })(),
          };
        }) || [];

      return {
        ...tariffItem,
        subService: updatedSubServices,
      };
    });
  }

  getAdditionalProperties(): { [key: string]: any } {
    const additionalProps: { [key: string]: any } = {};
    const dateFields = this.fields
      .filter((field) => field.type === 'date')
      .map((field) => field.name);
    this.addedFields.forEach(({ fieldName, controlName }) => {
      let value = this.fdaCreateForm.get(controlName)?.value ?? null;
      additionalProps[fieldName] = value;
      if (dateFields.includes(fieldName) && value) {
        additionalProps[fieldName] = formatToLocalISOString(value);
      }
    });
    return additionalProps;
  }

  formatToLocalISOString(dateInput: string | Date): string {
    const date = new Date(dateInput);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  formatFieldData(fields: any[]) {
    fields.forEach((field: any) => {
      switch (field.name.trim()) {
        case 'Country':
          field.options = this.countryList;
          this.filteredOptions[field.value] = field.options;
          break;
        case 'Port Agent':
          field.options = this.portAgentList.map((agent: any) => ({
            portagent_id: agent.company_id,
            name: agent.company_name,
          }));
          this.filteredOptions[field.value] = field.options;
          break;
        case 'Client':
          field.options = this.clientList.map((client: any) => ({
            client_id: client.company_id,
            name: client.company_name,
          }));
          this.filteredOptions[field.value] = field.options;
          break;
        case 'Cargo':
          field.options = this.cargoList;
          this.filteredOptions[field.value] = field.options;
          break;
        case 'Port':
          field.options = this.portList;
          this.filteredOptions[field.value] = field.options;
          break;
        case 'Vessel':
          field.options = this.vesselList;
          this.filteredOptions[field.value] = field.options;
          break;
        case 'Purpose':
          field.options = this.purposeList;
          this.filteredOptions[field.value] = field.options;
          break;
        case 'FromCurrency':
        case 'ToCurrency':
          field.options = this.currencyList;
          this.filteredOptions[field.value] = field.options;
          break;
        default:
      }
    });
  }

  convertVesselStayToMinutes = (vesselStay: string): number => {
    if (!vesselStay) return 0;

    const dayMatch = vesselStay.match(/(\d+)D/);
    const hourMatch = vesselStay.match(/(\d+)H/);

    const days = dayMatch ? parseInt(dayMatch[1], 10) : 0;
    const hours = hourMatch ? parseInt(hourMatch[1], 10) : 0;

    return days * 24 * 60 + hours * 60;
  };

  onSelect(fieldName: string, event: any) {
    if (fieldName === 'Country') {
      const currency = getCurrencyFromCountry(this.countryList, event.value);
      this.fdaCreateForm.patchValue({
        fda_currency_from: currency,
      });
      this.loader.show();
      this.portService.getPortsByCountryId(event.value).subscribe({
        next: (ports) => {
          this.portList = ports;
          this.formatFieldData(this.fields);
          this.loader.hide();
        },
        error: (error: any) => {
          this.portList = [];
          this.loader.hide();
          const errMsg = error?.error?.error;
          this.snackBar.error(errMsg);
        },
      });
    } else if (fieldName === 'Vessel') {
      const control = this.fdaCreateForm.get('vessel_id');
      const value = control?.value;
      const selectedVessel = this.vesselList.filter(
        (vessel) => vessel.vessel_id === value,
      );
      if (selectedVessel.length > 0) {
        const vessel = selectedVessel[0];
        this.fdaCreateForm.patchValue({
          imo_number: vessel.imo_number,
          nrt: vessel.nrt,
          grt: vessel.grt,
          rgrt: vessel.rgrt,
          depth: vessel.depth,
          loa: vessel.loa,
          beam: vessel.beam,
          type: vessel.type,
          dwt: vessel.dwt,
          vessel_id: vessel.vessel_id,
          vessel: vessel.name,
        });
        control?.setErrors(null);
      }
    } else if (fieldName === 'Client') {
      this.loader.show();
      const vslpayload = {
        company_id: this.fdaCreateForm.get('client_id')?.value,
        fields: ['assigned_unassigned'],
      };
      this.clientService.VslListFromDb(vslpayload).subscribe({
        next: (response: any) => {
          this.vesselList = response.assigned_vessels || [];
          this.formatFieldData(this.fields);
          this.loader.hide();
        },
        error: (error: any) => {
          this.vesselList = [];
          const errMsg =
            error?.error?.error || 'Failed to fetch vessel details';
          this.snackBar.error(errMsg);
          this.loader.hide();
        },
      });
    } else if (fieldName === 'Port') {
      const port_id = this.fdaCreateForm.get('port_id')?.value;
      removeAddedFieldsAndControls(
        this.fdaCreateForm,
        this.addedFields,
        this.fields,
      );
      this.addedFields = [];
      this.addedFields = addAdditionalFieldsToFieldsArray(
        port_id,
        this.portList,
        this.fields,
        this.fdaCreateForm,
        this.addedFields,
        this.filteredOptions,
        this.fb,
      );
      this.tariffrulesByPort(port_id);
    } else if (fieldName === 'Purpose') {
      const purposeId = this.fdaCreateForm.get('purpose_id')?.value;
      this.port_tariff_rule_calculate = new PA_Rules();
      if (
        this.previousPurposeId &&
        purposeId !== this.previousPurposeId &&
        this.isServiceCalculated
      ) {
        this.showDataLostWarning();
      } else {
        this.previousPurposeId = purposeId;
        const purpose = getPurposeName(this.purposeList, purposeId);
        if (purpose) {
          this.serviceList.items = filterServicesOnPurpose(
            purpose,
            this.portServiceList.items,
          );
        }
      }
    }
  }

  storePreviousFormData() {
    this.previousFormData = {
      ...this.fdaCreateForm.getRawValue(),
      serviceList: this.serviceList,
      merakiGrandTotal: this.merakiGrandTotal,
      datasource: [...this.datasource],
    };
  }

  restorePreviousFormData() {
    if (this.previousFormData) {
      this.fdaCreateForm.patchValue(this.previousFormData);
      this.serviceList = this.previousFormData.serviceList || new Rules();
      this.merakiGrandTotal = this.previousFormData.merakiGrandTotal || 0;
      this.datasource = this.previousFormData.datasource || [];
      this.populateServicesFromList();
    }
  }

  tariffrulesByPort(port_id: number) {
    const requestBody = {
      page: 1,
      page_size: 1,
      query_name: '',
      port_id: port_id,
    };
    this.loader.show();
    this.portService.getTariffRules(requestBody).subscribe({
      next: (res) => {
        this.serviceList.items = [];
        this.portServiceList = res?.data[0]?.rules;
        this.tariffRules = res?.data[0]?.rules;
        this.port_tariff_rule_calculate = new PA_Rules();
        const purposeId = this.fdaCreateForm.get('purpose_id')?.value;
        const purpose = this.purposeList.find(
          (p) => p.purpose_id === purposeId,
        )?.name;
        if (purpose) {
          this.serviceList.items = filterServicesOnPurpose(
            purpose,
            this.portServiceList.items,
          );
        }

        this.loader.hide();
      },
      error: (err) => {
        this.loader.hide();
        this.errMsg =
          err?.error?.error || 'Something went wrong please try again later.';
        this.snackBar.error(this.errMsg);
      },
    });
  }

  initForm() {
    this.fdaCreateForm.get('fdaFromPDA')?.valueChanges.subscribe((checked) => {
      const disbursementControl = this.fdaCreateForm.get('disbursementId');

      if (checked) {
        disbursementControl?.enable();
        this.submitButtonForAPI = true;
      } else {
        this.submitButtonForAPI = false;
        Object.keys(this.fdaCreateForm.controls).forEach((key) => {
          if (key !== 'fdaFromPDA') {
            this.fdaCreateForm.get(key)?.reset();
          }
        });
        disbursementControl?.disable({ emitEvent: false });
        this.disableFields();
        this.datasource = [];
        this.merakiGrandTotal = 0;
      }
    });
  }

  getDisbursmentDataFromDb(routeId?: string | null) {
    this.loader.show();
    this.fdaService.fdaDisbursementList().subscribe({
      next: (response: any) => {
        const disbursements: FdaDisbursementList[] = Array.isArray(
          response.data,
        )
          ? response.data
          : Array.isArray(response)
            ? response
            : [];
        this.disbursementIdList = [
          ...this.disbursementIdList,
          ...disbursements,
        ];
        this.disbursementId = disbursements.map(
          (item) => `${item.disbursement_id} - ${item.created_by || 'NA'}`,
        );
        this.disbursementSeq = disbursements.map(
          (item) => item.disbursement_seq,
        );
        this.filteredDisbursementId = [
          ...this.filteredDisbursementId,
          ...this.disbursementId,
        ];
        this.loader.hide();

        if (routeId) {
          this.fdaCreateForm.get('fdaFromPDA')?.setValue(true);
          const matchingDisbursement = this.disbursementId.find((d) =>
            d.startsWith(routeId),
          );
          if (matchingDisbursement) {
            this.fdaCreateForm.patchValue({
              disbursementId: matchingDisbursement,
            });
            this.onDisbursementSelected(matchingDisbursement);
          }
        }
      },
      error: (error) => {
        this.loader.hide();
      },
    });
  }

  onRemove(field: Field | string): void {
    if (typeof field === 'string') {
      const disbursementId = this.fdaCreateForm.get('disbursementId')?.value;
      if (field === 'disbursementId' && !disbursementId) {
        const fdaFromPDAValue = this.fdaCreateForm.get('fdaFromPDA')?.value;
        this.fdaCreateForm.reset();
        if (fdaFromPDAValue) {
          this.fdaCreateForm.get('fdaFromPDA')?.setValue(fdaFromPDAValue);
        }
        this.disableFields();
        this.datasource = [];
        this.merakiGrandTotal = 0;
      }
    } else {
      if (
        field?.name === 'Country' &&
        !this.fdaCreateForm.get('country_id')?.value
      ) {
        this.fdaCreateForm.get('port_id')?.setValue(null);
        this.portList = [];
        this.filteredOptions['port_id'] = [];
      } else if (
        field?.name === 'Client' &&
        !this.fdaCreateForm.get('client_id')?.value
      ) {
        this.fdaCreateForm.get('vessel_id')?.setValue(null);
        this.filteredOptions['vessel_id'] = [];
        this.vesselList = [];
        clearVesselDetails(this.fdaCreateForm);
      } else if (
        field?.name === 'Vessel' &&
        !this.fdaCreateForm.get('vessel_id')?.value
      ) {
        this.fdaCreateForm.get('vessel_id')?.setValue(null);
        clearVesselDetails(this.fdaCreateForm);
      } else if (
        field?.name === 'Vessel' &&
        !this.fdaCreateForm.get('vessel_id')?.value
      ) {
      }
    }
  }

  /* ** Needs to be reviewed with Team - PDA comments to be displayed in FDA -- Surjit 
  // Helper methods to get PDA data as fallback during FDA creation
  getPdaRemark(serviceName: string): string {
    // Check if we have PDA data from disbursement selection
    if (this.selectedDisbursementSeq && this.portServiceList?.items) {
      const pdaService = this.portServiceList.items.find(item => item.service === serviceName);
      return pdaService?.pa_remark || '';
    }
    return '';
  }

  getPdaFeedback(serviceName: string): string {
    // Check if we have PDA data from disbursement selection
    if (this.selectedDisbursementSeq && this.portServiceList?.items) {
      const pdaService = this.portServiceList.items.find(item => item.service === serviceName);
      return pdaService?.meraki_feedback || '';
    }
    return '';
  }
  */

  showDataLostWarning() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      panelClass: 'sweet-alert-style',
      data: {
        header: 'Data Loss Warning',
        text: 'Are you sure you want to change the purpose? This will reset the services.',
      },
    });

    dialogRef.afterClosed().subscribe((result: any[]) => {
      if (result) {
        const port_id = this.fdaCreateForm.get('port_id')?.value;
        this.tariffrulesByPort(port_id);
        this.serviceList.items = [];
        this.datasource = [];
        this.merakiGrandTotal = 0;
      } else {
        // Restore previous purpose and associated data
        this.fdaCreateForm.get('purpose_id')?.setValue(this.previousPurposeId);
      }
    });
  }

  
    isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
}
